import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { copy, products } from "../data/content";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer
      id="contact"
      data-testid="footer"
      className="border-t border-[#E5E5E5] bg-[#F2F2F0]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          {/* Impressum */}
          <div className="col-span-12 md:col-span-6 min-w-0">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="font-['Cormorant_Garamond'] text-4xl md:text-6xl tracking-tight text-[#111111]"
            >
              {t(copy.footer.heading)}
            </motion.h2>

            <div className="mt-10 font-['IBM_Plex_Mono'] text-sm leading-relaxed text-[#555555] space-y-1">
              <p className="text-[#111111] text-base">{copy.footer.name}</p>
              <p>{t(copy.footer.org)}</p>
            </div>

            <div className="mt-8">
              <span className="font-['IBM_Plex_Mono'] text-xs tracking-[0.2em] uppercase text-[#999999]">
                {t(copy.footer.contactLabel)}
              </span>
              <a
                href={`mailto:${copy.footer.email}`}
                data-testid="footer-email"
                className="group mt-2 flex items-center gap-2 w-fit max-w-full font-['IBM_Plex_Mono'] text-base md:text-lg text-[#111111] focus:outline-none focus:ring-1 focus:ring-black focus:ring-offset-2"
              >
                <span className="relative break-all">
                  {copy.footer.email}
                  <span className="absolute left-0 -bottom-1 h-px w-0 bg-[#111111] transition-[width] duration-500 group-hover:w-full" />
                </span>
                <ArrowUpRight
                  size={16}
                  className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <span className="font-['IBM_Plex_Mono'] text-xs tracking-[0.2em] uppercase text-[#999999]">
              {t(copy.products.heading)}
            </span>
            <ul className="mt-6 space-y-3">
              {products.map((p) => (
                <li key={p.id}>
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-link-${p.id}`}
                    className="group flex items-center justify-between border-b border-[#E5E5E5] pb-3 font-['IBM_Plex_Mono'] text-sm text-[#555555] hover:text-[#111111] transition-colors duration-300 focus:outline-none"
                  >
                    <span>{p.name}</span>
                    <ArrowUpRight
                      size={14}
                      className="text-[#999999] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-[#111111]"
                    />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-[#E5E5E5] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-['IBM_Plex_Mono'] text-xs tracking-[0.1em] uppercase text-[#999999]">
          <span>{t(copy.footer.rights)}</span>
          <span>© {new Date().getFullYear()} {copy.footer.name}</span>
        </div>
      </div>
    </footer>
  );
};
